<template>
  <div class="teen-index">
    <header class="page-header">
      <div class="header-icon">📚</div>
      <h1>青少年百科</h1>
      <p>探索知识的海洋，开启智慧之旅</p>
    </header>

    <div class="card-container">
      <div class="card-grid">
        <div
          v-for="item in items"
          :key="item.id"
          class="card-item"
          @click="navigateTo(item.path)"
        >
          <div class="card-image">
            <img :src="item.image" :alt="item.title">
            <div class="card-badge">{{ item.id + 1 }}</div>
            <div class="card-overlay">
              <span class="view-btn">
                <span class="btn-icon">▶</span>
                查看详情
              </span>
            </div>
          </div>
          <div class="card-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <div class="card-footer">
              <span class="read-time">📖 5分钟阅读</span>
              <span class="arrow">→</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="page-footer">
      <p>青少年百科 · 学习知识 探索世界</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'TeenIndex',
  data() {
    return {
      items: [
        {
          id: 0,
          title: '杂交水稻之父：袁隆平',
          description: '一粒种子改变世界的伟大科学家',
          image: 'https://img.moliaos.com/v/teen/teen_0.png',
          path: '/teen/0'
        },
        {
          id: 1,
          title: '青蒿素之母：屠呦呦',
          description: '拯救百万生命的医学先驱',
          image: 'https://img.moliaos.com/v/teen/teen_1.png',
          path: '/teen/1'
        },
        {
          id: 2,
          title: '天下第一奇山：黄山',
          description: '奇松怪石云海温泉四绝闻名',
          image: 'https://img.moliaos.com/v/teen/teen_2.png',
          path: '/teen/2'
        },
        {
          id: 3,
          title: '长江：中华民族的母亲河',
          description: '中国第一大河，世界第三长河',
          image: 'https://img.moliaos.com/v/teen/teen_3.png',
          path: '/teen/3'
        },
        {
          id: 4,
          title: '万里长城：世界的奇迹',
          description: '古代军事防御工程的巅峰之作',
          image: 'https://img.moliaos.com/v/teen/teen_4.png',
          path: '/teen/4'
        },
        {
          id: 5,
          title: '四大发明：中华文明的瑰宝',
          description: '造纸术、印刷术、火药、指南针',
          image: 'https://img.moliaos.com/v/teen/teen_5.png',
          path: '/teen/5'
        },
        {
          id: 6,
          title: '珠穆朗玛峰：世界之巅',
          description: '海拔8848.86米的地球最高点',
          image: 'https://img.moliaos.com/v/teen/teen_6.png',
          path: '/teen/6'
        },
        {
          id: 7,
          title: '兵马俑：地下的军团',
          description: '世界第八大奇迹，秦朝的震撼',
          image: 'https://img.moliaos.com/v/teen/teen_7.png',
          path: '/teen/7'
        },
        {
          id: 8,
          title: '敦煌莫高窟：艺术的殿堂',
          description: '丝绸之路上的艺术明珠',
          image: 'https://img.moliaos.com/v/teen/teen_8.png',
          path: '/teen/8'
        },
        {
          id: 9,
          title: '中国航天：探索宇宙',
          description: '从神舟到天宫，迈向星辰大海',
          image: 'https://img.moliaos.com/v/teen/teen_9.png',
          path: '/teen/9'
        },
        {
          id: 10,
          title: '中华美食：舌尖上的中国',
          description: '八大菜系，万千风味',
          image: 'https://img.moliaos.com/v/teen/teen_10.png',
          path: '/teen/10'
        },
        {
          id: 11,
          title: '中医文化：千年智慧',
          description: '望闻问切，辨证论治',
          image: 'https://img.moliaos.com/v/teen/teen_11.png',
          path: '/teen/11'
        },
        {
          id: 12,
          title: '茶文化：品茗之道',
          description: '琴棋书画诗酒茶',
          image: 'https://img.moliaos.com/v/teen/teen_12.png',
          path: '/teen/12'
        },
        {
          id: 13,
          title: '丝绸之路：文明纽带',
          description: '连接东西方的贸易通道',
          image: 'https://img.moliaos.com/v/teen/teen_13.png',
          path: '/teen/13'
        },
        {
          id: 14,
          title: '京剧艺术：国粹精华',
          description: '唱念做打，生旦净丑',
          image: 'https://img.moliaos.com/v/teen/teen_14.png',
          path: '/teen/14'
        }
      ]
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.teen-index {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 15px;
  padding-bottom: 80px;
}

.page-header {
  text-align: center;
  padding: 25px 15px 20px;
  color: white;
}

.header-icon {
  font-size: 3rem;
  margin-bottom: 10px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.page-header h1 {
  font-size: 1.8rem;
  margin: 0 0 8px 0;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  font-weight: 600;
}

.page-header p {
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.9;
  letter-spacing: 1px;
}

.card-container {
  max-width: 1200px;
  margin: 0 auto;
}

.category-tags {
  display: flex;
  gap: 10px;
  padding: 0 5px 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.category-tags::-webkit-scrollbar {
  display: none;
}

.tag {
  flex-shrink: 0;
  padding: 6px 16px;
  background: rgba(255,255,255,0.2);
  border-radius: 20px;
  font-size: 0.85rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255,255,255,0.3);
}

.tag.active,
.tag:hover {
  background: white;
  color: #667eea;
  border-color: white;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 0 5px;
}

.card-item {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  -webkit-tap-highlight-color: transparent;
}

.card-item:active {
  transform: scale(0.97);
}

.card-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.25);
}

.card-image {
  position: relative;
  height: 160px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.card-item:hover .card-image img {
  transform: scale(1.15);
}

.card-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a5a);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(255,107,107,0.4);
  z-index: 2;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.card-item:hover .card-overlay {
  opacity: 1;
}

.view-btn {
  background: white;
  color: #667eea;
  padding: 10px 24px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateY(10px);
  transition: transform 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.card-item:hover .view-btn {
  transform: translateY(0);
}

.btn-icon {
  font-size: 0.7rem;
}

.card-content {
  padding: 16px;
}

.card-content h3 {
  margin: 0 0 8px 0;
  font-size: 1.05rem;
  color: #222;
  line-height: 1.4;
  font-weight: 600;
}

.card-content p {
  margin: 0 0 12px 0;
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.read-time {
  font-size: 0.75rem;
  color: #999;
}

.arrow {
  color: #667eea;
  font-size: 1.2rem;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.card-item:hover .arrow {
  transform: translateX(5px);
}

.page-footer {
  text-align: center;
  padding: 30px 15px;
  color: rgba(255,255,255,0.7);
  font-size: 0.8rem;
}

@media (max-width: 768px) {
  .teen-index {
    padding: 12px;
    padding-bottom: 70px;
  }

  .page-header {
    padding: 20px 10px 15px;
  }

  .header-icon {
    font-size: 2.5rem;
  }

  .page-header h1 {
    font-size: 1.5rem;
  }

  .page-header p {
    font-size: 0.85rem;
  }

  .card-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 0;
  }

  .card-image {
    height: 110px;
  }

  .card-badge {
    top: 8px;
    left: 8px;
    width: 22px;
    height: 22px;
    font-size: 0.65rem;
  }

  .card-content {
    padding: 12px;
  }

  .card-content h3 {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }

  .card-content p {
    font-size: 0.75rem;
    margin-bottom: 8px;
    -webkit-line-clamp: 2;
  }

  .card-footer {
    padding-top: 8px;
  }

  .read-time {
    font-size: 0.65rem;
  }

  .arrow {
    font-size: 1rem;
  }

  .view-btn {
    padding: 8px 16px;
    font-size: 0.75rem;
  }
}

@media (max-width: 380px) {
  .teen-index {
    padding: 10px;
    padding-bottom: 60px;
  }

  .card-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .page-header {
    padding: 15px 8px 12px;
  }

  .header-icon {
    font-size: 2rem;
  }

  .page-header h1 {
    font-size: 1.3rem;
  }

  .page-header p {
    font-size: 0.75rem;
  }

  .card-image {
    height: 90px;
  }

  .card-badge {
    top: 6px;
    left: 6px;
    width: 18px;
    height: 18px;
    font-size: 0.55rem;
  }

  .card-content {
    padding: 8px;
  }

  .card-content h3 {
    font-size: 0.75rem;
    margin-bottom: 4px;
    line-height: 1.3;
  }

  .card-content p {
    font-size: 0.65rem;
    margin-bottom: 6px;
    -webkit-line-clamp: 2;
    line-height: 1.3;
  }

  .card-footer {
    padding-top: 6px;
  }

  .read-time {
    font-size: 0.6rem;
  }

  .arrow {
    font-size: 0.85rem;
  }

  .view-btn {
    padding: 6px 12px;
    font-size: 0.65rem;
  }

  .btn-icon {
    font-size: 0.55rem;
  }
}
</style>
